export default __webpack_public_path__ + "static/media/mapLocation.fcba3b11.svg";